import { BankConnection } from '@core/model/domain/bankConnection';
import { OkVal } from '@core/model/framework/Result/OkResult';
import { Usecase } from '@core/model/framework/usecase';
import type { BankService } from '@core/model/service/bankService';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';

export type AuthenticateToBankWithCredentialsInput = {
  bankId: string;
  form: {
    name: string;
    value?: string;
  }[];
  userId: string;
  userToken: string;
};
export type AuthenticateToBankWithCredentialsOuptput = Promise<OkVal<BankConnection>>;

@injectable()
export class AuthenticateToBankWithCredentials
  implements Usecase<AuthenticateToBankWithCredentialsInput, AuthenticateToBankWithCredentialsOuptput>
{
  constructor(
    @inject(SERVICE_ID.bankService)
    private readonly bankService: BankService
  ) {}
  async execute(input: AuthenticateToBankWithCredentialsInput): AuthenticateToBankWithCredentialsOuptput {
    return this.bankService.authenticateWithCredentials(input);
  }
}
